import React, { Component, useState, useEffect } from 'react';
import { useStore } from 'react-context-hook'
import { Platform, Stylesheet, Dimensions, Image, View, ScrollView, SafeAreaView, TouchableOpacity  } from 'react-native';
import DashboardMain from './DashboardMain.js';
import DashboardSub from './DashboardSub.js';
import MessageScreenNavigator from '../MessagesScreen';
import SearchScreenNavigator from '../SearchScreen'
import SandboxScreenNavigator from '../TestScreen'
import AboutScreenNavigator from '../AboutScreen'
import KBScreenNavigator from '../KnowledgeBaseScreen'
import ContactScreenNavigator from '../ContactScreen'
import SavedScreenNavigator from '../SavedScreen'
import Settings from '../SettingsScreen/index.js';
import { createDrawerNavigator, DrawerContentScrollView, DrawerItemList, DrawerItem } from '@react-navigation/drawer';
import { createStackNavigator, HeaderTitle } from '@react-navigation/stack';
import { NavigationContainer } from '@react-navigation/native';
import { Button, Icon, Container, Header, Footer, Content, Text } from 'native-base';
import { Layouts, PlatformDimensions } from '../../utils';
import Styles from '../../Styles'
import { color } from 'react-native-reanimated';
import SettingsStack from '../SettingsScreen/index.js'

const Drawer = createDrawerNavigator();

const screensList = [
    {
        name: 'DashboardMain',
        scrComp: DashboardMain,
        Title: 'Dashboard',
    },
    {
        name: 'DashboardSub',
        scrComp: DashboardSub,
        Title: 'Dashboard Sub',
    },
    {
        name: 'SettingsStack',
        scrComp: SettingsStack,
        Title: 'Settings Stack'
    }
]

function DashboardRoute({ route, navigation }) {
    return(
        <Layouts.GenerateStackRoutes screensList={screensList} route={route} navigation={navigation} />
    )
}

function CustomDrawerContent(props) {
    return (
        <DrawerContentScrollView style={{flex:1}} {...props}>
            <View style={{flex:5, flexDirection:'column', backgroundColor:Styles.Colors.colorPalette.mainColor}}>
                <View style={{height:200, width:null, backgroundColor:Styles.Colors.colorPalette.mainColor}}>
                    <Image style={{flex:1, height:200, width:200, padding:10 }} source={require('../../assets/HFCLogo.png')} />
                </View>

                <View style={{flex:1}}>
                    <DrawerItemList {...props} />
                </View>

            </View>
            {/* <View style={{ flex:1 }} >
                <DrawerItem label='Logout' />
            </View> */}
        </DrawerContentScrollView>
    )
}

const window = Dimensions.get('window');
const screen = Dimensions.get('screen');

function RootDrawer() {

    const [dimensions, setDimensions] = useState({window, screen});
    const [platform, setPlatform] = useStore('platform')
    const [desktopThreshold, setDesktopThreshold] = useStore('desktopThreshold')
    const [displayDesktop, setDisplayDesktop] = useStore('displayDesktop')

    const onChange = ({ window, screen }) => {
        setDimensions({ window, screen })
        setPlatform(Platform.OS)
        dimensions.window.width > desktopThreshold ? setDisplayDesktop(true) : setDisplayDesktop(false)
    };

    useEffect(() => {
        Dimensions.addEventListener('change', onChange);
        return () => {
            Dimensions.removeEventListener('change', onChange);
        }
    })

    return (
        //<NavigationContainer>
            <Drawer.Navigator initialRouteName='DashboardRoute' 
                drawerContent={props => <CustomDrawerContent {...props} />}
                //openByDefault={PlatformDimensions === 'web' ? 'true' : 'false'}
                drawerType={dimensions.window.width > desktopThreshold ? 'permanent' : 'front'}
                drawerStyle={{
                    width: 200,
                    backgroundColor:Styles.Colors.colorPalette.mainColor              
                }}                
                drawerContentOptions={{
                    activeTintColor: Styles.Colors.colorPalette.MenuSelected,
                    inactiveTintColor: Styles.Colors.colorPalette.White,
                }}
                >
                <Drawer.Screen 
                    name='Dashboard' 
                    component={DashboardRoute} 
                    options={{drawerIcon: ({focused}) => (
                                <Icon 
                                    name='home' 
                                    type='FontAwesome' 
                                    style={{color:focused ? Styles.Colors.colorPalette.MenuSelected : Styles.Colors.colorPalette.White}} />),
                        }} />
                <Drawer.Screen 
                    name='Messages' 
                    component={MessageScreenNavigator}
                    options={{drawerIcon: ({focused}) => (
                                <Icon 
                                    name='chat' 
                                    type='Entypo' 
                                    style={{color:focused ? Styles.Colors.colorPalette.MenuSelected : Styles.Colors.colorPalette.White}} />),
                        }} />
                <Drawer.Screen 
                    name='Search' 
                    component={SearchScreenNavigator}
                    options={{drawerIcon: ({focused}) => (
                                <Icon 
                                    name='search' 
                                    type='FontAwesome' 
                                    style={{color:focused ? Styles.Colors.colorPalette.MenuSelected : Styles.Colors.colorPalette.White}} />),
                        }} />
                <Drawer.Screen 
                    name='Saved' 
                    component={SavedScreenNavigator}
                    options={{drawerIcon: ({focused}) => (
                                <Icon 
                                    name='heart' 
                                    type='FontAwesome' 
                                    style={{color:focused ? Styles.Colors.colorPalette.MenuSelected : Styles.Colors.colorPalette.White}} />),
                        }} />
                <Drawer.Screen 
                    name='How Do I...' 
                    component={KBScreenNavigator}
                    options={{drawerIcon: ({focused}) => (
                                <Icon 
                                    name='questioncircleo' 
                                    type='AntDesign' 
                                    style={{color:focused ? Styles.Colors.colorPalette.MenuSelected : Styles.Colors.colorPalette.White}} />),
                        }} />
                <Drawer.Screen 
                    name='About Us' 
                    component={AboutScreenNavigator}
                    options={{drawerIcon: ({focused}) => (
                                <Icon 
                                    name='open-book' 
                                    type='Entypo' 
                                    style={{color:focused ? Styles.Colors.colorPalette.MenuSelected : Styles.Colors.colorPalette.White}} />),
                        }} />
                <Drawer.Screen 
                    name='Contact Us' 
                    component={ContactScreenNavigator}
                    options={{drawerIcon: ({focused}) => (
                                <Icon 
                                    name='contacts' 
                                    type='AntDesign' 
                                    style={{color:focused ? Styles.Colors.colorPalette.MenuSelected : Styles.Colors.colorPalette.White}} />),
                        }} />
                <Drawer.Screen 
                    name='TestScreen' 
                    component={SandboxScreenNavigator}
                    options={{drawerIcon: ({focused}) => (
                                <Icon 
                                    name='lab-flask' 
                                    type='Entypo' 
                                    style={{color:focused ? Styles.Colors.colorPalette.MenuSelected : Styles.Colors.colorPalette.White}} />),
                        }} />
               
                
                {/* <Drawer.Screen name='Settings' component={Settings} /> */}
            </Drawer.Navigator>
        //</NavigationContainer>
    )
}

export default RootDrawer;
 